import React from "react";
import { ShiftAdjustMealBreak, MealBreak } from "./ShiftAdjustMealBreak";
import {
  ShiftAdjustMealBreaksContainer,
  BreakAddButton,
  BreakAddButtonContainer,
} from "./styledComponents";

export type ShiftAdjustMealBreaksProps = {
  mealBreaks: MealBreak[];
  onUpdateMealBreak: (mealBreak: MealBreak) => void;
  onDeleteMealBreak: (id: string) => void;
  onAddMealBreak: () => void;
  maxBreaks?: number;
  formattedTimezone?: string;
};

export const ShiftAdjustMealBreaks = ({
  mealBreaks,
  onUpdateMealBreak,
  onDeleteMealBreak,
  onAddMealBreak,
  maxBreaks = 3,
  formattedTimezone,
}: ShiftAdjustMealBreaksProps) => {
  const canAddMoreBreaks = mealBreaks.length < maxBreaks;

  return (
    <ShiftAdjustMealBreaksContainer>
      {mealBreaks.map((mealBreak, index) => (
        <ShiftAdjustMealBreak
          key={mealBreak.id}
          mealBreak={mealBreak}
          breakNumber={index + 1}
          onUpdate={onUpdateMealBreak}
          onDelete={onDeleteMealBreak}
          formattedTimezone={formattedTimezone}
        />
      ))}

      {canAddMoreBreaks && (
        <BreakAddButtonContainer>
          <BreakAddButton label="Add a break" onClick={onAddMealBreak} />
        </BreakAddButtonContainer>
      )}
    </ShiftAdjustMealBreaksContainer>
  );
};
